import { Component, inject, Input } from '@angular/core';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { CountBoxComponent } from '../../atoms/count-box/count-box.component';

@Component({
  selector: 'app-count-box-poi',
  standalone: true,
  imports: [CountBoxComponent],
  templateUrl: './count-box-poi.component.html',
  styleUrl: './count-box-poi.component.scss',
})
export class CountBoxPoiComponent {
  readonly store = inject(DataLayerTypeStore);
  @Input() title = 'Standorte';
  @Input() text = '';
  @Input() styleClass = '';
}
